/**
 * Czyste stałe i logika decyzji o zgodzie na cookies.
 * Bez zależności od Nuxt — testowalne w środowisku Node.
 */
export const CONSENT_COOKIE_NAME = 'lavmag_cookie_consent'

/**
 * Nazwa cookie zgody dla marki: własna z BrandConfig.consentCookieName albo
 * domyślna (lavmag, youlook, discanto — zmiana unieważniłaby ich zapisane zgody).
 */
export function consentCookieName(brand: { consentCookieName?: string }): string {
  return brand.consentCookieName || CONSENT_COOKIE_NAME
}

/** Podbij gdy zmienią się kategorie — stary cookie = „brak decyzji" (ponowne pytanie). */
export const CONSENT_VERSION = 1

/** ~12 miesięcy w sekundach. */
export const CONSENT_COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export interface ConsentChoice {
  analytics: boolean
  marketing: boolean
}

export interface StoredConsent extends ConsentChoice {
  v: number
  ts: number
}

export function isValidStoredConsent(value: unknown): value is StoredConsent {
  if (!value || typeof value !== 'object') return false
  const v = value as Record<string, unknown>
  return typeof v.v === 'number'
    && typeof v.analytics === 'boolean'
    && typeof v.marketing === 'boolean'
}

/**
 * Zwraca wybór użytkownika tylko gdy cookie jest poprawny i w aktualnej wersji.
 * W innym przypadku null = „brak decyzji" → pokaż baner.
 */
export function readDecision(value: unknown): ConsentChoice | null {
  if (!isValidStoredConsent(value)) return null
  if (value.v !== CONSENT_VERSION) return null
  return { analytics: value.analytics, marketing: value.marketing }
}
